import { useState } from "react";
import { useLocation } from "react-router-dom";

import { Logo } from "../../components/Logo";
import Login from "./Login";
import Register from "./Register";
import Reset from "./Reset";
import NewPassword from "./NewPassword";

export const AuthenticationView = ({ supabaseClient }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [screen, setScreen] = useState(
    currentPath === "/new-password" ? "new-password" : "login"
  );

  const handleScreenChange = (screen) => {
    setScreen(screen);
  };

  return (
    <div className="auth-page">
      <div>
        {screen == "login" && (
          <Login
            handleScreenChange={handleScreenChange}
            supabaseClient={supabaseClient}
          />
        )}
        {screen == "new-password" && (
          <NewPassword
            handleScreenChange={handleScreenChange}
            supabaseClient={supabaseClient}
          />
        )}
        {screen == "register" && (
          <Register
            handleScreenChange={handleScreenChange}
            supabaseClient={supabaseClient}
          />
        )}
        {screen == "reset" && (
          <Reset
            handleScreenChange={handleScreenChange}
            supabaseClient={supabaseClient}
          />
        )}
      </div>
      <div className="auth-right-screen">
        <Logo color={"white"} />
        <div className="auth-quote">
          <p style={{ fontSize: "20px" }}>
            Headless Ticketing is the new wave in Live-Entertainment - it
            fosters innovation and it will revitalize Live-Entertainment
            Ticketing. Welcome!
          </p>
        </div>
      </div>
    </div>
  );
};
